import React, { useMemo } from "react";
import clsx from "clsx";

import { IActiveLearningIssue } from "../../../../../../state";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import ThemeVideo from "../../../../../ActiveLearning/ThemeVideo";
import styles from "../../../ActiveLearningIssue.module.scss";
import hintImage01 from "../../../../../../assets/images/ActiveLearning/hint/img_01.webp";

type Issue1MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue1Material = (props: Issue1MaterialProps) => {
  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          社会で活躍する大人たちは、それぞれの『正解のない「問い」』に答えを出すための課題解決に取り組んでいる。
          <br />
          選んだテーマに関する動画を見よう。
        </p>
      </div>
      <ThemeVideo />
      {question1 && (
        <div className={clsx(styles.question, styles.primary)}>
          <div className={styles.themEntry}>
            <p className={styles.title}>{question1.title}</p>
            <p className={styles.read}>
              ヒントを参考にして、動画を見て気づいたことや、感じたことを入力しよう。
            </p>
            <p className={styles.example}>
              例：動画では、〇〇という課題に、〇〇を使って取り組んでいた。/動画の中にあった〇〇という部分が自分にはなかった考え方なので面白かった。/自分だったら〇〇の問題に対して〇〇ができるかもしれないと思った。
            </p>
            <div className={styles.textAreaWrapper}>
              <TextArea />
            </div>
          </div>
        </div>
      )}
      <img src={hintImage01} alt="感想を入力する際のヒント" />
    </div>
  );
};
export default Issue1Material;
